import React, { memo, useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, orgId,
}) {
  const accFilter = useMemo(
    () => ({ org: orgId, kdb: row.kdb ? row.kdb.id : null }),
    [orgId, row.kdb],
  );
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.DateInput
          value={row.datefrom}
          onChange={(e, v) => actions.onChange(e, row.id, { datefrom: v })}
          readOnly={fields.datefrom.read_only || readOnly}
        />
      </TableCell>
      <TableCell>
        <TableControls.ItemPicker
          value={row.kdb}
          onChange={(e, v) => actions.onChange(e, row.id, { kdb: v })}
          readOnly={fields.kdb.read_only || readOnly}
          backend={fields.kdb.resource}

        />
      </TableCell>
      <TableCell>
        <TableControls.ItemPicker
          value={row.account}
          onChange={(e, v) => actions.onChange(e, row.id, { account: v })}
          readOnly={fields.account.read_only || readOnly}
          backend={fields.account.resource}
          filter={accFilter}
          disabled={!row.kdb}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    datefrom: PropTypes.string,
    kdb: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    account: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
  }).isRequired,
  fields: PropTypes.shape({
    datefrom: PropTypes.shape({ read_only: PropTypes.bool }),
    kdb: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    account: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  orgId: PropTypes.number.isRequired,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
};

export default memo(Row);
